interface CacheEntry<T> {
  data: T;
  timestamp: number;
  ttl: number;
}

export class Cache {
  private static instance: Cache;
  private cache = new Map<string, CacheEntry<any>>();

  private constructor() {}

  static getInstance(): Cache {
    if (!Cache.instance) {
      Cache.instance = new Cache();
    }
    return Cache.instance;
  }

  set<T>(key: string, data: T, ttl: number = 60000): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      ttl
    });
  }

  get<T>(key: string): T | null {
    const entry = this.cache.get(key);
    if (!entry) return null;

    const now = Date.now();
    if (now - entry.timestamp > entry.ttl) {
      this.cache.delete(key);
      return null;
    }

    return entry.data as T;
  }

  invalidate(key?: string): void {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }

  clear(): void {
    this.cache.clear();
  }
}

export const withCache = async <T>(
  key: string,
  fetchFn: () => Promise<T>,
  ttl: number = 60000 // TTL default of 1 minute
): Promise<T> => {
  const cache = Cache.getInstance();
  const cached = cache.get<T>(key);
  
  if (cached) {
    console.log(`Cache hit for ${key}`);
    return cached;
  }

  console.log(`Cache miss for ${key}`);
  const data = await fetchFn();
  cache.set(key, data, ttl);
  return data;
};